import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C6.615 2.25 2.25 6.615 2.25 12C2.25 17.385 6.615 21.75 12 21.75C17.385 21.75 21.75 17.385 21.75 12C21.75 6.615 17.385 2.25 12 2.25ZM11.47 16.28C11.6106 16.4205 11.8012 16.4993 12 16.4993C12.1988 16.4993 12.3894 16.4205 12.53 16.28L15.53 13.28C15.6037 13.2113 15.6628 13.1285 15.7038 13.0365C15.7448 12.9445 15.7668 12.8452 15.7686 12.7445C15.7704 12.6438 15.7518 12.5438 15.7141 12.4504C15.6764 12.357 15.6203 12.2722 15.549 12.201C15.4778 12.1297 15.393 12.0736 15.2996 12.0359C15.2062 11.9982 15.1062 11.9796 15.0055 11.9814C14.9048 11.9832 14.8055 12.0052 14.7135 12.0462C14.6215 12.0872 14.5387 12.1463 14.47 12.22L12.75 13.94V8.25C12.75 8.05109 12.671 7.86032 12.5303 7.71967C12.3897 7.57902 12.1989 7.5 12 7.5C11.8011 7.5 11.6103 7.57902 11.4697 7.71967C11.329 7.86032 11.25 8.05109 11.25 8.25V13.94L9.53 12.22C9.38782 12.0875 9.19978 12.0154 9.00548 12.0188C8.81118 12.0223 8.62579 12.101 8.48838 12.2384C8.35097 12.3758 8.27225 12.5612 8.26882 12.7555C8.2654 12.9498 8.33752 13.1378 8.47 13.28L11.47 16.28Z"
        fill={colorValue}
      />
    </svg>
  );
};
